//@vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const Immutable = require('immutable');
//@commons
const { formatText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
//@components
const TaxAdditionalCountryEdit = require('components/myProfile/taxAdditionalCountryList/taxAdditionalCountryEdit');
//@constants
const { countryOptions, MAX_TAX_COUNTRIES } = require('constants/countries');
const newCountry = Immutable.fromJS({ paisTributacion: '', indTipoTributacion: '', tin: { codigodocumpersonacorp: '' } });

class TaxAdditionalCountryForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            adding: props.AddingFlag,
        };

        this.handleAddingToggle = this.handleAddingToggle.bind(this);
        this.handleAddingButton = this.handleAddingButton.bind(this);
        this.handleSaveNewCountry = this.handleSaveNewCountry.bind(this);
    }

    handleAddingButton() {
        const { setAddingTaxAdditionalCountry } = this.props;
        if (setAddingTaxAdditionalCountry) {
            setAddingTaxAdditionalCountry(true);
        }
        this.setState({ adding: true });
    }

    handleAddingToggle() {
        const { setAddingTaxAdditionalCountry } = this.props;
        if (setAddingTaxAdditionalCountry) {
            setAddingTaxAdditionalCountry(!this.state.adding);
        }
        this.setState({ adding: !this.state.adding })
    }

    handleSaveNewCountry(index, data) {
        this.handleAddingToggle();
        this.props.onSaveCountry(index, data);
    }

    render() {
        const {
            immCountries,
            onDeleteCountry,
            onSaveCountry,
            setEditingTaxAdditionalCountry,
            setAddingTaxAdditionalCountry,
            tinLength,
            tinRegex,
            addNoTin,
            disableAdd,
            disableEdit,
            disableRemove,
            originCountry,
            onHandleNextDisableButton
        } = this.props;

        const { adding } = this.state;
        const countriesUsed = immCountries.map(country => country.get('paisTributacion'));
        let newCountryElement, formListCountries;
        const buttonAdd = !adding && immCountries.size < MAX_TAX_COUNTRIES[originCountry] ? (
            <div className="step-one__add-country-button-container">
                <OKButton
                    modifier="ghost"
                    onClick={this.handleAddingButton}
                    leftIcon="icon-agregar"
                >
                    {formatText("profile-profileAddCountryTributationLabel")}
                </OKButton>
            </div>
        ) : null;

        if (adding) {
            const countriesAvailables = countryOptions().filter((country) => countriesUsed.indexOf(country.value) < 0);
            newCountryElement = (
                <TaxAdditionalCountryEdit
                    onHandleNextDisableButton={onHandleNextDisableButton}
                    immCountry={newCountry}
                    index={immCountries.size}
                    isNew={true}
                    addNoTin={addNoTin}
                    onDeleteCountry={onDeleteCountry}
                    onSaveCountry={this.handleSaveNewCountry}
                    onCancelNewCountry={this.handleAddingToggle}
                    countriesAvailbles={countriesAvailables}
                    tinLength={tinLength}
                    tinRegex={tinRegex}
                    disableEdit={disableEdit}
                    disableRemove={disableRemove}
                    disableBorderBottom={disableAdd}
                    setEditingTaxAdditionalCountry={setAddingTaxAdditionalCountry}
                />
            );
        }

        if (immCountries) {
            formListCountries = immCountries.map((item, index) => {
                const countriesAvailables = countryOptions().filter((country) => country.value === item.get('paisTributacion') || countriesUsed.indexOf(country.value) < 0);
                return (
                    <TaxAdditionalCountryEdit
                        onHandleNextDisableButton={onHandleNextDisableButton}
                        immCountry={item}
                        index={index}
                        isNew={false}
                        addNoTin={addNoTin}
                        key={item.get('paisTributacion')}
                        onDeleteCountry={onDeleteCountry}
                        onSaveCountry={onSaveCountry}
                        countriesAvailbles={countriesAvailables}
                        tinLength={tinLength}
                        tinRegex={tinRegex}
                        disableEdit={disableEdit}
                        disableRemove={disableRemove}
                        disableBorderBottom={disableAdd}
                        setEditingTaxAdditionalCountry={setEditingTaxAdditionalCountry}
                    />
                )
            })
        }

        return (
            <div>
                {formListCountries}
                {newCountryElement}
                {!disableAdd && buttonAdd}
            </div>
        );
    }
}

TaxAdditionalCountryForm.propTypes = {
    originCountry: PropTypes.string.isRequired,
    immCountries: PropTypes.object,
    onDeleteCountry: PropTypes.func,
    onSaveCountry: PropTypes.func,
    AddingFlag: PropTypes.bool,
    addNoTin: PropTypes.bool,
    disableAdd: PropTypes.bool,
    disableEdit: PropTypes.bool,
    disableRemove: PropTypes.bool,
    tinLength: PropTypes.number,
    tinRegex: PropTypes.any,
    setAddingTaxAdditionalCountry: PropTypes.func,
    setEditingTaxAdditionalCountry: PropTypes.func,
    onHandleNextDisableButton: PropTypes.func
};

module.exports = connect(
    state => ({
        originCountry: state.profile.get('originCountry')
    })
)(TaxAdditionalCountryForm);
